import { render } from "./profileTwo.vue?vue&type=template&id=99ce4d90"
import script from "./profileTwo.vue?vue&type=script&lang=js"
export * from "./profileTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__